import { Component, h, Prop, Event, EventEmitter, getMode, Fragment } from '@stencil/core';
import { SubMenuRow } from '../../ds-contextual-navigation';
import clsx from 'clsx';
import { ActivityMapRegion, emitClickTrackerEvent, hashCode } from '../../../../utils/utils';
import { Labels, translate } from '../../../../utils/translations';

@Component({
  tag: 'ds-header-submenu-row',
  styleUrls: {
    default: 'ds-header-submenu-row.scss',
    light: 'ds-header-submenu-row.scss'
  }
})
export class HeaderSubmenuRow {
  @Prop() subMenuRow: SubMenuRow;
  @Prop() subMenuTitle: string;
  @Prop() isExploreMenu: boolean = false;
  @Prop() isAdjustable: boolean = false;

  @Event() blurSubmenuLink: EventEmitter;

  render() {
    if (!this.subMenuRow) {
      return null;
    }

    return (
      <div
        class={clsx('submenu-row', {
          'submenu-row--explore': this.isExploreMenu,
          'submenu-row--adjustable': this.isAdjustable
        })}
        data-mode={getMode(this)}
      >
        {this.subMenuRow.subMenuLinkItems?.map((itemBlock, index) => {
          const id = hashCode(`${index}-${this.subMenuTitle}-${itemBlock.category}`);
          return (
            <div class='submenu-row__column'>
              {itemBlock.category ? (
                <p class='submenu-row__category'>
                  {itemBlock.url ? (
                    <ds-link
                      href={itemBlock.url}
                      onClick={(event) =>
                        emitClickTrackerEvent(
                          {
                            componentName: ActivityMapRegion.Header,
                            title: `CNL: ${this.subMenuTitle} > ${itemBlock.category}`,
                            url: itemBlock.url,
                            originEvent: event
                          },
                          { hasUiActions: false }
                        )
                      }
                      onFocusout={(e) => this.blurSubmenuLink.emit(e)}
                      type='secondary'
                      id={id}
                    >
                      {itemBlock.category}
                      <ds-icon aria-hidden='true' name='NavigationArrowRight' size='small' />
                    </ds-link>
                  ) : (
                    <p id={id} class='submenu-row__category-text'>
                      {itemBlock.category}
                    </p>
                  )}
                </p>
              ) : null}
              <ul
                class='submenu-row__links'
                {...(itemBlock.category ? { 'aria-labelledby': id } : {})}
              >
                {itemBlock.items?.map((item) => {
                  return (
                    <li
                      class={clsx('submenu-row__link', {
                        'submenu-row__link--category': itemBlock.displayItemsAsCategoryLink
                      })}
                    >
                      {item.title === '-' && !item.url ? (
                        <div class='submenu-row__divider' />
                      ) : (
                        <p class='submenu-row__ceo-paragraph'>
                          <ds-link
                            href={item.url}
                            onClick={(event) =>
                              emitClickTrackerEvent(
                                {
                                  componentName: ActivityMapRegion.Header,
                                  title: `CNL: ${this.subMenuTitle} > ${
                                    itemBlock.category ? `${itemBlock.category} > ` : ''
                                  }${item.title}`,
                                  url: item.url,
                                  originEvent: event
                                },
                                { hasUiActions: false }
                              )
                            }
                            onFocusout={(e) => this.blurSubmenuLink.emit(e)}
                            type='secondary'
                            target={
                              item.externalLink && !itemBlock.displayItemsAsCategoryLink
                                ? '_blank'
                                : null
                            }
                          >
                            {item.title}
                            {itemBlock.displayItemsAsCategoryLink ? (
                              <ds-icon
                                aria-hidden='true'
                                name='NavigationArrowRight'
                                size='small'
                              />
                            ) : null}
                            {item.externalLink && !itemBlock.displayItemsAsCategoryLink ? (
                              <Fragment>
                                <span class='submenu-row__external-label'>
                                  {translate(Labels['Navigation.LinkTargetBlank'])}
                                </span>
                                <ds-icon
                                  aria-hidden='true'
                                  name='ExternalLink'
                                  class='submenu-row__external-icon'
                                />
                              </Fragment>
                            ) : null}
                          </ds-link>
                        </p>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    );
  }
}
